// extracted by css-extract-rspack-plugin
var _1 = "wpfLu";
export { _1 as "fallbackIcon" }
